import React, {Component} from 'react';
import {Translate} from 'react-localize-redux';
import './style.css';
import {Button} from "reactstrap";
import {ACTIONS, getSystemStatus, updateSystemSetting} from "../../../../01-actions/system";
import {connect} from "react-redux";

class Dashboard extends Component {
	constructor(props) {
		super(props);
		props.getSystemStatus();
	}
	
	render() {
		return (
			<Translate>
				{({translate}) =>
					<div className="pages-admin-dashboard">
						<div className="header">Dashboard</div>
						<div className="content">
							{this.props.systemStatus &&
							<div className="maintain-control">
								<div className="head">Maintain mode</div>
								<div className="body">
									<div className="d-flex justify-content-between margin-bottom-15px">
										<div>Current status</div>
										<div>{this.props.systemStatus.MAINTAIN_MODE ? "ON" : "OFF"}</div>
									</div>
									<div>
										<Button
											onClick={() => {
												this.props.updateSystemSetting({
													name: "MAINTAIN_MODE",
													value: !this.props.systemStatus.MAINTAIN_MODE
												});
											}}
											disabled={[ACTIONS.FETCH_STATUS_PROGRESS, ACTIONS.UPDATE_SETTING_PROGRESS].indexOf(this.props.status) >= 0}
											className={[ACTIONS.FETCH_STATUS_PROGRESS, ACTIONS.UPDATE_SETTING_PROGRESS].indexOf(this.props.status) >= 0 ? "progress-button" : ""}
										>{this.props.systemStatus.MAINTAIN_MODE ? "Turn off" : "Turn on"}</Button>
									</div>
								</div>
							</div>
							}
						</div>
					</div>
				}
			</Translate>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		status: store.system.status,
		systemStatus: store.system.systemStatus
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSystemStatus: () => {
			dispatch(getSystemStatus());
		},
		updateSystemSetting: (data) => {
			dispatch(updateSystemSetting(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Admin/Dashboard/index.js